import types from "./types";

import homePageData from "../../data/home";

const initialState = {
  banners: homePageData.banners,
  featuredProfile: homePageData.featured.profile,
  featuredPosts: homePageData.featured_posts,
  events: homePageData.events,
  onboarding: homePageData.onboarding,
  userCourses: homePageData.user_courses,
  recommendedCourses: homePageData.recommended_courses,
  showHomePageMsg: false,
  homePageMsg: "",
  fixedFooter: false,
  checkContent: {},
  breadcrumbStack: [],
  sectionLazyLoad: {
    myOnboarding: false,
    myArea: false,
    myWall: false,
    myRecommend: false,
  },
  smartBar: {},
  loginLogo: {},
  activeHeader: {},
  showChangePassword: {},
  isLoadingGlobal:false,
  blinkLive: false,
  blinkNotification: false,
  showLoader: false,
  newContentCount: {},
  googleClientId:"",
  activeLanguage: "1"
};

const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FIXED_FOOTER:
      return {
        ...state,
        fixedFooter: true,
      };
    case types.FIXED_FOOTER_CLEAR:
      return {
        ...state,
        fixedFooter: false,
      };
    case types.HOME_MSG:
      return {
        ...state,
        homePageMsg: action.payload,
      };

    case types.HOME_MSG_CLEAR:
      return {
        ...state,
        homePageMsg: "",
      };

    case types.SHOW_HOME_MSG:
      return {
        ...state,
        showHomePageMsg: action.payload,
      };

    case types.CONTENT_ACCESS_RESPONSE:
      return {
        ...state,
        checkContent: action.payload,
      };

    case types.CONTENT_ACCESS_CLEAR:
      return {
        ...state,
        checkContent: {},
      };

    case types.BREADCRUMB_STACK:
      console.log(action.payload);
      return {
        ...state,
        breadcrumbStack: action.payload,
      };

    case types.CLEAR_BREADCRUMB_STACK:
      return {
        ...state,
        breadcrumbStack: [],
      };

    case types.SECTION_LAZY_LOAD:
      return {
        ...state,
        sectionLazyLoad: action.payload,
      };

    case types.CLEAR_SECTION_LAZY_LOAD:
      return {
        ...state,
        sectionLazyLoad: {
          myOnboarding: false,
          myArea: false,
          myWall: false,
          myRecommend: false,
        },
      };
    case types.SMART_BAR_RESPONSE:
      return {
        ...state,
        smartBar: action.payload,
      };

    case types.SMART_BAR_CLEAR:
      return {
        ...state,
        smartBar: {},
      };

    case types.LOGIN_LOGO_RESPONSE:
      return {
        ...state,
        loginLogo: action.payload,
      };

    case types.LOGIN_LOGO_CLEAR:
      return {
        ...state,
        loginLogo: {},
      };
      case types.GOOGLE_CLIENT_ID:
      return {
        ...state,
        googleClientId: action.payload,
      };

    case types.GOOGLE_CLIENT_ID_CLEAR:
      return {
        ...state,
        googleClientId: "",
      };
    case types.ACTIVE_HEADER:
      console.trace("pay---",action.payload);
      return {
        ...state,
        activeHeader: action.payload,
      };
    case types.ACTIVE_HEADER_CLEAR:
      return {
        ...state,
        activeHeader: {},
      };
      case types.SHOW_CHANGE_PASSWORD:
      return {
        ...state,
        showChangePassword: action.payload,
      };
    case types.SHOW_CHANGE_PASSWORD_CLEAR:
      return {
        ...state,
        showChangePassword: {},
      };
case types.IS_LOADING:
      return {
        ...state,
        isLoadingGlobal: action.payload,
      };
    case types.IS_LADING_CLEAR:
      return {
        ...state,
        isLoadingGlobal: false,
      };

    case types.BLINK_LIVE:
    console.log('BLINK LIVE REDUCER', action.payload)
      return {
          ...state,
          blinkLive: action.payload
      }
    case types.BLINK_NOTIFICATION:
    console.log('BLINK NOTIFICATION REDUCER', action.payload)
      return {
          ...state,
          blinkNotification: action.payload
      }
    case types.SHOW_LOADER:
      return {
        ...state,
        showLoader: action.payload
      }
    case types.SHOW_LOADER_CLEAR:
      return {
        ...state,
        showLoader: false
      }
      case types.NEW_CONTENT_COUNT_RESPONSE:
        return {
          ...state,
          newContentCount: action.payload
        }
      case types.NEW_CONTENT_COUNT_RESPONSE_CLEAR:
        return {
          ...state,
          newContentCount: false
        }
        case types.ACTIVE_LANGUAGE:
          console.trace("pay---",action.payload);
          return {
            ...state,
            activeLanguage: action.payload,
          };
        case types.ACTIVE_LANGUAGE_CLEAR:
          return {
            ...state,
            activeLanguage: {},
          };
    default:
      return state;
  }
};

export default homeReducer;
